(ns app.survey.login.sms.event
  (:require
   [ajax.core :as ajax]
   [app.survey.event :as app-event]
   [app.survey.login.sms.state :as state]
   [app.survey.login.sms.sub :as sub]
   [app.survey.sub :as app-sub]
   [common.localization :as loc]
   [common.phone-util :as phone-util]
   [common.util :as cu]
   [frontend.logging :as logging]
   [re-frame.core :as rf]
   [ui.components.alert-list.event :as alert-list-event]))

(rf/reg-event-fx
 ::edit-phone
 (fn [{db :db} [_ phone-text]]
   (let [validate-timeout-handle (get db ::sub/validate-timeout-handle)]
     (when validate-timeout-handle
       (js/clearTimeout validate-timeout-handle))
     (let [new-timeout-handle (js/setTimeout
                               #(rf/dispatch [::validate-phone])
                               2500)]
       {:db (-> db
                (assoc ::sub/phone phone-text)
                (assoc ::sub/validate-timeout-handle new-timeout-handle)
                (assoc ::sub/phone-validated? false))}))))

(rf/reg-event-fx
 ::validate-phone
 (fn [{db :db} [_]]
   (let [validate-timeout-handle (get db ::sub/validate-timeout-handle)
         phone (get db ::sub/phone)
         valid-phone? (boolean (phone-util/valid-phone-number-str? phone))]
     (when validate-timeout-handle
       (js/clearTimeout validate-timeout-handle))
     {:db (-> db
              (dissoc ::sub/validate-timeout-handle)
              (assoc ::sub/valid-phone? valid-phone?)
              (assoc ::sub/phone-validated? true))})))

(rf/reg-event-fx
 ::edit-email-token
 (fn [{db :db} [_ token-text]]
   {:db (-> db
            (assoc ::sub/email-token token-text))}))

(rf/reg-event-fx
 ::edit-sms-token
 (fn [{db :db} [_ token-text]]
   {:db (-> db
            (assoc ::sub/sms-token token-text))}))

(rf/reg-event-fx
 ::cancel-sms-verification
 (fn [{db :db} _]
   {:db (assoc db ::sub/state ::state/no-phone-registered)}))

(rf/reg-event-fx
 ::cancel-login-process
 (fn [{db :db} _]
   {:db         (assoc db ::sub/state ::state/logging-out)
    :http-xhrio {:method          :post
                 :uri             "/login/api/logout"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::app-event/logout]
                 :on-failure      [::app-event/on-logout-failed]}}))

(rf/reg-event-fx
 ::submit-sms-token-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login submit SMS failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/sent-sms-token))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      5000
            :variant         :danger
            :message-content [:div
                              (str (get-in err [:response :message]))]}]]]}))

(rf/reg-event-fx
 ::submit-sms-token-ok
 (fn [{db :db} [_ resp]]
   (let [ok-or-tries-left (:body resp)
         ok? (= ok-or-tries-left :ok)
         new-state (cond ok?
                         ::state/auth-ok
                         :else
                         ::state/sent-sms-token)
         tries-left (if (number? ok-or-tries-left)
                      ok-or-tries-left
                      5)]
     (merge {:db (-> db
                     (assoc ::sub/state new-state)
                     (assoc ::sub/tries-left tries-left))}
            (if ok?
              {:fx [[:dispatch [::app-event/load-app-config true]]]}
              {:fx [[:dispatch
                     [::alert-list-event/add-alert
                      {:list-id         :login-notifications
                       :hide-in-ms      3000
                       :variant         :danger
                       :message-content [:div
                                         (loc/tr :could-not-verify-sms-token)]}]]]})))))

(rf/reg-event-fx
 ::submit-sms-token
 (fn [{db :db} _]
   (let [token (get db ::sub/sms-token)
         email (get db ::sub/email)]
     {:db         (-> db
                      (assoc ::sub/state ::state/submitting-sms-token))
      :http-xhrio {:method          :post
                   :uri             "/login/api/submit-sms-token"
                   :params          {:sms-token token
                                     :email     email}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::submit-sms-token-ok]
                   :on-failure      [::submit-sms-token-failed]}})))

(rf/reg-event-fx
 ::submit-email-token-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login submit EMAIL token failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/sent-email-token))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      5000
            :variant         :danger
            :message-content [:div
                              (str (get-in err [:response :message]))]}]]]}))

(rf/reg-event-fx
 ::submit-email-token-ok
 (fn [{db :db} [_ resp]]
   (let [ok-or-tries-left (:body resp)
         ok? (= ok-or-tries-left :ok)
         new-state (cond ok?
                         ::state/auth-ok
                         :else
                         ::state/sent-email-token)
         tries-left (if (number? ok-or-tries-left)
                      ok-or-tries-left
                      5)]
     (merge {:db (-> db
                     (assoc ::sub/state new-state)
                     (assoc ::sub/tries-left tries-left))}
            (if ok?
              {:fx [[:dispatch [::app-event/load-app-config true]]]}
              {:fx [[:dispatch
                     [::alert-list-event/add-alert
                      {:list-id         :login-notifications
                       :hide-in-ms      3000
                       :variant         :danger
                       :message-content [:div
                                         (loc/tr :could-not-verify-email-token)]}]]]})))))

(rf/reg-event-fx
 ::submit-email-token
 (fn [{db :db} _]
   (let [token (get db ::sub/email-token)]
     {:db         (-> db
                      (assoc ::sub/state ::state/submitting-sms-token))
      :http-xhrio {:method          :post
                   :uri             "/login/api/submit-email-token"
                   :params          {:email-token token}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::submit-email-token-ok]
                   :on-failure      [::submit-email-token-failed]}})))

(rf/reg-event-fx
 ::register-phone
 (fn [{db :db}]
   {:db (-> db
            (assoc ::sub/state ::state/no-phone-registered))}))

(rf/reg-event-fx
 ::send-sms-token
 (fn [{db :db}]
   {:db (-> db
            (assoc ::sub/state ::state/sent-sms-token))}))

(rf/reg-event-fx
 ::check-email-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login check email failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/error))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      5000
            :variant         :danger
            :message-content [:div
                              (str (get-in err [:response :message]))]}]]]}))

(rf/reg-event-fx
 ::check-email-ok
 (fn [{db :db} [_ resp]]
   (let [masked-phone (some->> resp
                               :body
                               :masked-phone)
         new-state (cond (cu/blank-value? masked-phone)
                         ::state/no-phone-registered
                         :else
                         ::state/sent-sms-token)]
     {:db (-> db
              (assoc ::sub/state new-state)
              (assoc ::sub/masked-phone masked-phone))})))

(rf/reg-event-fx
 ::submit-email
 (fn [{db :db}]
   (let [email (get db ::sub/email)]
     {:db         (-> db
                      (assoc ::sub/state ::state/checking-email))
      :http-xhrio {:method          :post
                   :uri             "/login/api/check-email-and-send-sms"
                   :params          {:email email}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::check-email-ok]
                   :on-failure      [::check-email-failed]}})))

(rf/reg-event-fx
 ::init
 (fn [{db :db}]
   (let [masked-email (get db ::app-sub/invited-email)
         masked-phone (get db ::app-sub/phone-number)
         new-state (if (cu/blank-value? masked-phone)
                     ::state/no-phone-registered
                     ::state/sent-sms-token)]
     (js/console.log "Init " new-state " << " masked-email " " masked-phone)
     {:db (-> db
              (assoc ::sub/state new-state)
              (assoc ::sub/masked-email masked-email)
              (assoc ::sub/masked-phone masked-phone))}
     )))

(rf/reg-event-fx
 ::send-phone-verification-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login send verification sms failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/no-phone-registered))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      3000
            :variant         :danger
            :message-content [:div
                              (loc/tr :could-not-send-sms)]}]]]}))

(rf/reg-event-fx
 ::send-phone-verification-ok
 (fn [{db :db} [_ resp]]
   (let [masked-phone (some->> resp
                               :body
                               :masked-phone)
         new-state (cond (cu/blank-value? masked-phone)
                         ::state/no-phone-registered
                         :else
                         ::state/verify-phone-number)]
     {:db (-> db
              (assoc ::sub/state new-state)
              (assoc ::sub/masked-phone masked-phone))})))


(rf/reg-event-fx
 ::submit-phone
 (fn [{db :db}]
   (let [email (get db ::sub/email)
         phone (get db ::sub/phone)]
     {:db         (-> db
                      (assoc ::sub/state ::state/submitting-phone))
      :http-xhrio {:method          :post
                   :uri             "/login/api/send-verification-sms"
                   :params          {:email email
                                     :phone phone}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::send-phone-verification-ok]
                   :on-failure      [::send-phone-verification-failed]}})))

(rf/reg-event-fx
 ::send-email-token-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login send verification email failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/no-phone-registered))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      3000
            :variant         :danger
            :message-content [:div
                              (loc/tr :could-not-send-email)]}]]]}))

(rf/reg-event-fx
 ::send-email-token-ok
 (fn [{db :db} [_ resp]]
   (let [ok (some->> resp
                     :body
                     (= :ok))
         new-state ::state/sent-email-token]
     {:db (-> db
              (assoc ::sub/state new-state))})))

(rf/reg-event-fx
 ::send-email-token
 (fn [{db :db}]
   {:db         (-> db
                    (assoc ::sub/state ::state/submitting-email-token))
    :http-xhrio {:method          :post
                 :uri             "/login/api/send-verification-email"
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::send-email-token-ok]
                 :on-failure      [::send-email-token-failed]}}))

(rf/reg-event-fx
 ::submit-verification-tokens-failed
 (fn [{db :db} [_ err]]
   (logging/error "Login submit verification sms and email failed : " err)
   {:db (-> db
            (assoc ::sub/state ::state/verify-phone-number))
    :fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      5000
            :variant         :danger
            :message-content [:div
                              (str (get-in err [:response :message]))]}]]]}))

(rf/reg-event-fx
 ::submit-verification-tokens-ok
 (fn [{db :db} [_ resp]]
   (let [ok-or-tries-left (some->> resp
                                   :body)
         new-state (cond (= :ok ok-or-tries-left)
                         ::state/auth-ok
                         :else
                         ::state/verify-phone-number)
         tries-left (if (number? ok-or-tries-left)
                      ok-or-tries-left
                      5)]
     (merge {:db (-> db
                     (assoc ::sub/state new-state)
                     (assoc ::sub/tries-left tries-left))}
            (if (= :ok ok-or-tries-left)
              {:fx [[:dispatch [::app-event/load-app-config true]]]}
              {:fx [[:dispatch
                     [::alert-list-event/add-alert
                      {:list-id         :login-notifications
                       :hide-in-ms      5000
                       :variant         :danger
                       :message-content [:div
                                         (loc/tr :could-not-verify-tokens)]}]]]})))))

(rf/reg-event-fx
 ::submit-verification-tokens
 (fn [{db :db}]
   (let [email (get db ::sub/email)
         phone (get db ::sub/phone)
         sms-token (get db ::sub/sms-token)
         email-token (get db ::sub/email-token)]
     {:db         (assoc db :sub/state ::state/submitting-verification-tokens)
      :http-xhrio {:method          :post
                   :uri             "/login/api/verify-sms-and-email"
                   :params          {:email       email
                                     :phone       phone
                                     :sms-token   sms-token
                                     :email-token email-token}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::submit-verification-tokens-ok]
                   :on-failure      [::submit-verification-tokens-failed]}})))
